import type { QueryFunctionContext } from '@tanstack/react-query';
import { AdminService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { adminWorkspacesKeys } from 'app/queries/adminWorkspaces/adminWorkspacesKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof adminWorkspacesKeys.allList>>;

export const createFetchAllAdminWorkspacesQueryFn =
  (call: TCall) =>
  async ({ signal }: TParams) =>
    (await call(() => cancelOnSignal(AdminService.getAllWorkspacesList(), signal))) ?? [];
